// Frozen contract types for the deterministic sim core.
// Shapes here match docs/TECH_SPEC.md §2 — update the spec before changing anything.

export type ObstacleType = 'spike' | 'bar' | 'gap';

/**
 * Track-generation versions the dual-path generator supports (TECH_SPEC
 * §4bis.24). Exactly two per design §7.1 (最多两个 sim_version): the current
 * SIM_VERSION and the one before it. Generation is keyed by the track row's
 * PERSISTED sim_version so old share links regenerate byte-identically forever.
 */
export type GenVersion = '3' | '4';

/** x = left edge, w = width, both in FQ (1 grid = 1024). */
export interface Obstacle {
  type: ObstacleType;
  x: number;
  w: number;
}

export enum Action {
  Jump = 0,
  SlideStart = 1,
  SlideEnd = 2,
  Revive = 3,
}

/** f = sim frame (0-based, 60 Hz), ascending (non-decreasing). */
export interface InputEvent {
  f: number;
  a: Action;
}

/** Wall-clock pause marker; does not affect simulation. d = duration in ms. */
export interface PauseEvent {
  f: number;
  d: number;
}

export interface SimState {
  frame: number;
  /** FQ. x = distance along track, y = height above ground (up positive). */
  x: number;
  y: number;
  vy: number;
  sliding: boolean;
  slideFrames: number;
  grounded: boolean;
  dead: boolean;
  finished: boolean;
  /** −1 while alive. */
  deathFrame: number;
  revivesUsed: number;
  invulnFrames: number;
}

export interface RunResult {
  /** false → invalid input stream; reason set. */
  ok: boolean;
  reason?: string;
  deathFrame: number;
  finished: boolean;
  distanceFQ: number;
  distanceM: number;
  /** FNV-1a 32-bit over (x, y) every 6th frame, lowercase hex. */
  posHash: string;
  inputCount: number;
}

export interface TrackValidation {
  ok: boolean;
  issues: string[];
}
